import { useFormContext } from 'react-hook-form'

const HiddenInput = ({ name, defaultValue, required = true }) => {
    const { register } = useFormContext()

    return (
        <input
            type="hidden"
            name={name}
            defaultValue={defaultValue}
            {...register(name, { required })} />
    )
}

export default HiddenInput